import React from 'react'
import { Outlet, useLocation } from 'react-router'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import { ScrollRestoration } from 'react-router-dom'
import { useAxios } from '../hooks/useAxios'
import { getNotificationsCount } from '../api/getNotificationsCount'
import { toast } from 'react-toastify'
import { NotificationsStore } from '../store/notificationsStore'

function DashboardLayout(): JSX.Element {
  const location = useLocation()
  const { fire } = useAxios()

  React.useEffect(() => {
    fire(getNotificationsCount()).then(({ response, error }) => {
      if (!error) {
        const count: number = +(response?.data ?? 0)
        NotificationsStore.setCount(count)
      } else {
        toast.error(error.message)
      }
    })
  }, [location])

  return (
    <>
      <div className={'dashboard-layout'}>
        <Sidebar></Sidebar>
        <div className="dashboard-layout__inner">
          <main className="dashboard-layout__view">
            <div className="container">
              <div className="dashboard-layout__view-inner">
                <Outlet></Outlet>
              </div>
            </div>
          </main>
          <Header></Header>
        </div>
      </div>
      <ScrollRestoration
        getKey={(location) => {
          return location.pathname
        }}
      ></ScrollRestoration>
    </>
  )
}

export default DashboardLayout
